import { IconFn, IconSvg } from "../createIcon";

export const EditIcon: IconFn = ({ color = "#655C94", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 18, height: 18 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.185.198a.676.676 0 0 1 .957 0l4.66 4.662a.676.676 0 0 1 0 .956l-11.71 11.71A1.618 1.618 0 0 1 4.948 18H.676A.676.676 0 0 1 0 17.324v-4.272c0-.429.17-.84.474-1.144L9.52 2.861 12.185.198Zm2.475 6.847 1.707-1.707-3.704-3.705-1.708 1.707 3.705 3.705Zm-4.662-2.75-8.568 8.57a.266.266 0 0 0-.077.187v3.595h3.595c.07 0 .138-.028.187-.077L13.703 8 9.998 4.297Z"
      fill={color}
    />
  </IconSvg>
);
